import { fill } from './fill.js'
import { FreeTrialReportCardProvincialGr16202309 as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'pvrc1to6_2023_09',
  label: 'Provincial Report - Gr. 1–6',
  templateUrl,
  fill,
  Page,
}
